import { render, staticRenderFns } from "./right-arrow.vue?vue&type=template&id=25ea1dd2&scoped=true"
import script from "./right-arrow.vue?vue&type=script&lang=js"
export * from "./right-arrow.vue?vue&type=script&lang=js"
import style0 from "./right-arrow.vue?vue&type=style&index=0&id=25ea1dd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ea1dd2",
  null
  
)

export default component.exports